import React from 'react';
import PropTypes from 'prop-types';
import Card from '../Card';
import * as Style from './style';

const CardWithTitle = ({ title, icon, children }) => (
	<>
		<Card padding="0" overflow="hidden">
			<Style.Title role="region">
				{icon && (
					<div role="img" data-test="icon">
						{ icon }
					</div>
				)}
				<em>{ title }</em>
			</Style.Title>
			<Style.Content role="region">
				{ children }
			</Style.Content>
		</Card>
	</>
);

CardWithTitle.defaultProps = {
	icon: '',
};

CardWithTitle.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.element,
		PropTypes.elementType,
	]).isRequired,
	title: PropTypes.string.isRequired,
	icon: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.element,
		PropTypes.elementType,
	]),
};

export default CardWithTitle;
